import { render } from "./CookiesNotEnabled.vue?vue&type=template&id=b9ceb612"
import script from "./CookiesNotEnabled.vue?vue&type=script&lang=js"
export * from "./CookiesNotEnabled.vue?vue&type=script&lang=js"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__